export const Green = (
    <svg fill="currentColor" height="26" width="26">
        <path d="M3.923 6.277a3.138 3.138 0 0 1 3.139-3.139h9.415a6.277 6.277 0 0 1 6.277 6.277H7.062a3.138 3.138 0 0 1-3.139-3.138zM3.923 18.83a3.138 3.138 0 0 1 3.139-3.138h15.692a6.277 6.277 0 0 1-6.277 6.277H7.062a3.138 3.138 0 0 1-3.139-3.138z" />
        <path d="M16.477 9.415h6.277v6.277h-6.277z" />
    </svg>
);
